/**
 * A pipe that iterates over an object and
 * returns it's individual keys and values
 */
import {
    Pipe, PipeTransform
} from "@angular/core";

@Pipe({ name: "mgdTitleCaseSplit" })
export class TitleCaseSplitPipe implements PipeTransform {

    transform(value: string): any {

        if (value) {
            const segments = value.match(/[A-ZÀ-Ÿ][a-zà-ÿ'.,]*/gm);

            return (segments ? segments.join(" ") : value);
        }
        else {
            return "";
        }
    }
}
